
import React, { Component } from 'react'
import { connect } from "react-redux";
import { Helmet } from 'react-helmet-async';
// intl messages
import IntlMessages from 'Util/IntlMessages'; 
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';

// app config
import AppConfig from 'Constants/AppConfig';

import {
   Card,
   CardTitle
} from 'reactstrap';

import {
  allAcademyStudentsList,
  allAcademys,
  allStudents,
  ParentFullDetails,
} from 'Actions';


class ParentDashbaord extends Component {

  constructor(props) {
     
     super(props);
     this.state = {
        academydiv:false,
        sudentdiv:true,
         
     };      
      
     
      //this.onBackSection = this.onBackSection.bind(this);  
 }

  UNSAFE_componentWillMount() {
   
     this.props.allStudents();
     var stdid=localStorage.getItem('user_id'); 
     this.props.ParentFullDetails(stdid);
     //this.props.allAcademys();
  }

  academyselect(id){

     // this.props.allAcademyStudentsList(id).then((data) => {         
     //    if(data.status==1){
     //       this.setState({
     //          academydiv:false,
     //          sudentdiv: true,
     //       });
     //    }
     // });
  }

   render() {
      const { match } = this.props;
      const { studentlists, academylists, academystudentslist, parentfulldetails, loading } = this.props;

      const styles = {
        maindiv: {             
            cursor: "pointer",
            hover:{
              backgroundColor: "salmon",
              color: "white"
            }
        }
        
      };
      return (
         <div className="saas-dashboard">
            <Helmet>
               <title>Dashboard | {AppConfig.appTitle}</title>
               <meta name="description" content="Reactify Sass Dashboard" />
            </Helmet>
            <PageTitleBar title={<IntlMessages id="sidebar.saas" />} match={match} />
           
            {this.state.sudentdiv &&
                 <div className="row">
                     <div className="col-sm-12 col-lg-3">
                        <div className="text-center studendet">
                        <img
                           src={AppConfig.apiurl+'/theme/img/profile_images/'+(parentfulldetails && parentfulldetails.studentimage)}
                           alt="Student Profile" style={{width:"60%", height:"60%"}}
                        />
                        <div><strong>{parentfulldetails && parentfulldetails.studentname}</strong></div>
                        </div>
                        <div className="text-center"></div>
                     </div> 
                     <div className="col-sm-12 col-lg-9">
                        <div className="dddd">
                        <a href="/app/contract/viewagreement"><button type="button" className="mr-10 mb-10 btn btn-info">View Agreement</button></a>
                        <a href="/app/contract/viewdocument"><button type="button" className="mr-10 mb-10 btn btn-info">View Documents</button></a>
                        </div>
                     </div>
                 </div>
           } 
        </div>
      )
   }
}

const mapStateToProps = ({ academy, mostlyused }) => {
  const { academylists } = academy;
   const { studentlists, academystudentslist, parentfulldetails, loading } = mostlyused;
   return { studentlists, academylists, academystudentslist, parentfulldetails, loading };
}

export default connect(mapStateToProps, {
  allAcademyStudentsList,
  allAcademys,
  allStudents,
  ParentFullDetails
})(ParentDashbaord); 
